export const pawelMurawski = {
    'meta': {
        'title': 'Psychoterapeuta w trakcie szkolenia Paweł Murawski • COLLIGO',
        'description': 'Jestem uczestnikiem 4-letniego szkolenia psychoterapeutycznego. Od ponad 10 lat zajmuję się szeroko pojętym wsparciem psychologicznym osób dorosłych.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-pawel-murawski/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/pawel-murawski.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta w Toruniu Paweł Murawski'
        }
    }
}